import { useAuthStore } from '@/stores';
import { configSettings } from '@/lib/config';
import { useCommunities } from '../queries/useCommunities';

/**
 * Hook to build the community URL with authentication token.
 * Returns null if no community is available or required data is missing.
 *
 * @returns The community URL with token, or null if unavailable
 *
 * @example
 * ```tsx
 * const communityUrl = useCommunityUrl();
 *
 * if (communityUrl) {
 *   return <a href={communityUrl} target="_blank">Community</a>;
 * }
 * ```
 */
export const useCommunityUrl = (): string | null => {
    const { data: communitiesData } = useCommunities();
    const token = useAuthStore(state => state.token);

    const communities = communitiesData?.communities || [];
    const community = communities[0];
    const hasMultipleCommunities = communities.length > 1;
    const destinationPage = hasMultipleCommunities ? '' : community?.slug || '';

    if (!community || !token || !configSettings.communityDomain) {
        return null;
    }

    return `${configSettings.communityDomain}/${destinationPage}?token=${token}`;
};
